<div class="tc-loading" *ngIf="loading" role="status">Loading…</div>
<div class="br-flex br-items-center br-gap-2 br-p-3" *ngIf="error" role="alert">
  <span>{{ error }}</span><button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="load()">Retry</button>
</div>
      <div class="tc-table-wrap" *ngIf="page.items.length">
      <table class="tc-table">
        <thead>
          <tr>
            <th class="sk-dot-th"></th>
            <th>Provider</th>
            <th *ngIf="service.hasModel">Default model</th>
            <th>Secret key</th>
            <th>Note</th>
            <th class="col-actions col-actions-3">
              <button type="button" class="br-btn br-btn--ghost br-icon-btn" *ngIf="canManage()" (click)="add()" title="Add key">
                <br-icon>add</br-icon>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of page.items; trackBy: trackById">
            <td class="sk-dot-cell">
              <span class="sk-dot" [class.on]="c.primary" [title]="c.primary ? 'Company default' : ''"></span>
            </td>
            <td class="muted">{{ meta(c)?.label || c.provider }}</td>
            <td class="muted" *ngIf="service.hasModel">{{ c.model || '—' }}</td>
            <td class="muted sk-mono">{{ c.secretMasked }}</td>
            <td class="muted">{{ c.note || '—' }}</td>
            <td class="col-actions col-actions-3">
              <button type="button" class="icon-btn br-btn br-btn--ghost br-icon-btn" *ngIf="canManage()"
                      title="Set as company default" [disabled]="c.primary" (click)="setPrimary(c)"><br-icon>check</br-icon></button>
              <button type="button" class="icon-btn br-btn br-btn--ghost br-icon-btn" *ngIf="canManage()" title="Edit" (click)="edit(c)"><br-icon>edit</br-icon></button>
              <button type="button" class="icon-btn danger br-btn br-btn--ghost br-icon-btn" *ngIf="canManage()" title="Remove" (click)="remove(c)"><br-icon>delete</br-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <app-api-key-editor *ngIf="inlineCreate && canManage() && !loading && !error && !page.items.length"
                          [inline]="true" [service]="service.id" (saved)="load(1)"></app-api-key-editor>

      <div class="sk-emptybar" *ngIf="!loading && !error && !page.items.length && !(inlineCreate && canManage())">
        <span class="sk-empty-text">{{ canManage() ? 'No key yet.' : 'No key yet. Ask your administrator to add one.' }}</span>
        <button type="button" class="br-btn br-btn--ghost br-icon-btn" *ngIf="canManage()" (click)="add()" title="Add key">
          <br-icon>add</br-icon>
        </button>
      </div>

      <mat-paginator
        *ngIf="page.total > page.pageSize"
        [length]="page.total"
        [pageIndex]="page.page - 1"
        [pageSize]="page.pageSize"
        [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons
        (page)="onPage($event)">
      </mat-paginator>
